import { businessConfig } from '../config/business';

export function formatMoney(cents: number, currency = businessConfig.defaultCurrency): string {
  return new Intl.NumberFormat(businessConfig.defaultLocale, {
    style: 'currency',
    currency,
  }).format(cents / 100);
}

export function calculateCartTotal(items: Array<{ priceCents: number; quantity: number }>): number {
  return items.reduce((total, item) => total + item.priceCents * item.quantity, 0);
}
